import axios from "axios";

// Configurăm instanța Axios
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "https://backend.arnoldbots.ro",
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor pentru cereri: Adăugăm token-ul de autentificare
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Token-ul este stocat în localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Adaugă token-ul în header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // În caz de eroare, o respingem
  }
);

// Interceptor pentru răspunsuri: Gestionăm erorile
apiClient.interceptors.response.use(
  (response) => response, // Dacă totul merge bine, întoarce răspunsul
  (error) => {
    if (error.response && error.response.status === 401) {
      alert("Autentificare eșuată. Te rugăm să te loghezi din nou.");
      window.location.href = "/login"; // Redirecționează utilizatorul la pagina de login
    } else if (error.response && error.response.status === 403) {
      alert("Nu ai permisiunea să accesezi această resursă.");
    } else {
      console.error("Eroare:", error.message); // Alte erori
    }
    return Promise.reject(error); // Returnăm eroarea pentru debugging
  }
);

export default apiClient;
